import { createRef, useRef } from 'react';

import { createSafeContext } from '@blockworks/ui/utils';

const useVisualizationState = () => {
    const visualizationRef = useRef<HTMLDivElement>(null);

    return {
        visualizationRef,
    };
};

type VisualizationContext = ReturnType<typeof useVisualizationState>;

const [VisualizationContextProvider, useVisualizationContext] = createSafeContext<VisualizationContext>({
    strict: false,
    name: 'VisualizationContext',
    hookName: 'useVisualizationContext',
    providerName: 'VisualizationContextProvider',
    defaultValue: {
        visualizationRef: createRef(),
    },
});

type VisualizationProviderProps = React.PropsWithChildren;

/**
 * A context provider for an individual visualization.
 *
 * This is currently (as of 3/6/25) implemented in VisualizationRenderer to
 * keep track of the visualization wrapper ref and legend ref in order to more
 * easily support the image capture feature. Although, this can be extended to be responsible
 * for more shared state for each individual visualization.
 */
const VisualizationProvider = ({ children }: VisualizationProviderProps) => {
    const value = useVisualizationState();

    return <VisualizationContextProvider value={value}>{children}</VisualizationContextProvider>;
};

export type { VisualizationContext, VisualizationProviderProps };
export { useVisualizationContext, VisualizationProvider };
